import { render, staticRenderFns } from "./ActivityStatistics.vue?vue&type=template&id=0b23f00c&scoped=true"
import script from "./ActivityStatistics.vue?vue&type=script&lang=js"
export * from "./ActivityStatistics.vue?vue&type=script&lang=js"
import style0 from "./ActivityStatistics.vue?vue&type=style&index=0&id=0b23f00c&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23f00c",
  null
  
)

export default component.exports